"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const environment_1 = require("../../../service-lib/src/lib/environment");
const axios_1 = tslib_1.__importDefault(require("axios"));
const schedule_1 = require("@nestjs/schedule");
const ioredis_1 = tslib_1.__importDefault(require("ioredis"));
let AppService = class AppService {
    constructor() {
        this.servicesKey = 'servicesInfo';
        this.services = [];
        this.storageType = environment_1.ENV.STORAGE_TYPE || 'local'; // Default to 'local' if not set
        if (this.storageType === 'valkey') {
            this.redis = new ioredis_1.default({
                host: environment_1.ENV.VALKEY_HOST,
                port: environment_1.ENV.VALKEY_PORT ? parseInt(environment_1.ENV.VALKEY_PORT, 10) : 6379,
                tls: {}
                // password: ENV.VALKEY_PASSWORD || 'xyz',
                // lazyConnect: true,
            });
            // this.redis = new Redis(redisOptions);
            this.redis.on('error', (err) => {
                this.storageType = 'local';
                console.error('Valkey connection error:', err);
            });
            this.redis.on('connect', () => {
                console.log('Connected to Valkey');
            });
        }
    }
    getData() {
        return { message: "Service registry running successfully.." };
    }
    async getStoredServices() {
        const data = await this.redis.get(this.servicesKey);
        return data ? JSON.parse(data) : [];
    }
    async storeServices(services) {
        await this.redis.set(this.servicesKey, JSON.stringify(services));
    }
    async registerService(serviceInfo) {
        if (this.storageType === 'valkey') {
            const services = await this.getStoredServices();
            const existingIndex = services.findIndex((service) => service.name === serviceInfo.name);
            if (existingIndex === -1) {
                services.push(serviceInfo);
            }
            else {
                services[existingIndex] = { ...services[existingIndex], ...serviceInfo };
            }
            await this.storeServices(services);
            console.log("valkey service List", services);
            return { success: true, message: `Service ${serviceInfo.name} registered to valkey` };
        }
        else {
            const serviceExists = this.services.find((service) => service.name === serviceInfo.name);
            console.log(serviceInfo.name + " status : ", serviceExists);
            if (!serviceExists) {
                this.services.push(serviceInfo);
            }
            else {
                console.log("Service already registered, updating status");
                const existingService = this.services.find((service) => service.name === serviceInfo.name);
                if (existingService) {
                    existingService.status = serviceInfo.status;
                }
            }
            console.log("local service List", this.services);
            return { success: true, message: `Service ${serviceInfo.name} registered` };
        }
    }
    async getAllServices() {
        if (this.storageType === 'valkey') {
            return await this.getStoredServices();
        }
        else {
            return Array.from(this.services);
        }
    }
    async getService(name) {
        if (this.storageType === 'valkey') {
            const services = await this.getStoredServices();
            return services.find((service) => service.name === name);
        }
        else {
            return this.services.find((service) => service.name === name);
        }
    }
    async unregisterService(name) {
        if (this.storageType === 'valkey') {
            console.log("Unregistering service : ", name);
            const services = await this.getStoredServices();
            const serviceIndex = services.findIndex((service) => service.name === name);
            if (serviceIndex !== -1) {
                services.splice(serviceIndex, 1);
                await this.storeServices(services);
            }
            console.log("valkey service List", services);
            return { success: true, message: `Service ${name} unregistered` };
        }
        else {
            console.log("Unregistering service : ", name);
            const serviceIndex = this.services.findIndex((service) => service.name === name);
            this.services.splice(serviceIndex, 1);
            console.log("local service List", this.services);
            return { success: true, message: `Service ${name} unregistered` };
        }
    }
    //@Cron('*/20 * * * * *') // Every 20 seconds
    //@Cron(this.healtCheckInterval) // Every 20 seconds
    async checkServicesHealth() {
        if (this.storageType === 'valkey') {
            console.log("Checking services health...");
            const services = await this.getStoredServices();
            for (const service of services) {
                try {
                    const res = await axios_1.default.get(service.url + service.healthCheck);
                    console.log('Service :' + service.name + ' Health is :' + res.status);
                    service.status = 'active';
                }
                catch (err) {
                    console.log('Service :' + service.name + ' is down');
                    service.status = 'inactive';
                }
            }
            await this.storeServices(services);
        }
        else {
            console.log("Checking services health...");
            for (const service of [...this.services]) { // Use a copy of the array to avoid mutation issues
                try {
                    const res = await axios_1.default.get(service.url + service.healthCheck);
                    console.log('Service :' + service.name + ' Health is :' + res.status);
                    service.status = 'active';
                }
                catch (err) {
                    console.log('Service :' + service.name + ' is down');
                    service.status = 'inactive'; // Update the service status to inactive
                    //this.services.splice(this.services.indexOf(service), 1); // Remove the service
                }
            }
        }
    }
};
exports.AppService = AppService;
tslib_1.__decorate([
    (0, schedule_1.Cron)(function () {
        const healthCheckInterval = environment_1.ENV.HEALTH_CHECK_DURATION || 20; // Default to 20 seconds if not set
        return `*/${healthCheckInterval} * * * * *`;
    }()) // Every 20 seconds
    //@Cron(this.healtCheckInterval) // Every 20 seconds
    ,
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", Promise)
], AppService.prototype, "checkServicesHealth", null);
exports.AppService = AppService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__metadata("design:paramtypes", [])
], AppService);
